









































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import AxAPI from '@/api';

type Group = I.AxZone;

type PageInfo = I.MealSettingPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  listReader: I.MealReaderDetail[];
  listMealTime: I.MealTimeData[];

  mealDate: string;
  mealDateMenu: boolean;

  empno: string;
  userName: string;

  mealType: number;
  mealReader: number;
  mealCnt: number;

  constructor() {
    this.listReader = [];
    this.listMealTime = [];

    this.mealDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
    this.mealDateMenu = false;

    this.empno = '' as never;
    this.userName = '' as never;

    this.mealType = '' as never;
    this.mealReader = '' as never;
    this.mealCnt = 1;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
  zoneCode!: number;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.meal.configGet();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '카드',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '현금',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class DialogHandler extends BaseClass {
  showReaderSelectDialog() {
    this.showCodeSelectDialog({
      title: '리더기 선택',
      param: {
        items: this.pageInfo.listMealReader.filter(x => x.zoneCode === this.zoneCode),
        selected: this.dataItem.state.listReader,
        headers: [
          { text: '이름', value: 'doorName', align: 'start' },
          { text: '코너', value: 'cornerName', align: 'start' }
        ],
        callback: async (selected: I.MealReaderDetail[]) => {
          this.dataItem.state.listReader = selected;
        }
      },
      single: true
    });
  }

  showEmployeeSearchDialog() {
    type EmployeeSearchDialogParams = { param: I.DataParam };

    const dialogParams = new I.DialogParam<EmployeeSearchDialogParams>(
      'AxSearchMealEmployeeDialog',
      {
        param: {
          items: [],
          selected: [],
          callback: async () => {
            const selected = dialogParams.props.param.selected[0] as I.User;
            if (!selected) return;

            this.dataItem.state.empno = selected.empno;
            this.dataItem.state.userName = selected.name;
          }
        }
      }
    );
    this.showDialog(dialogParams);
  }

  showMealTypeSelectDialog() {
    if (!this.dataItem.state.listReader.length) return;
    const mealReader = this.dataItem.state.listReader[0];

    this.showCodeSelectDialog({
      title: '식수 유형 선택',
      param: {
        items: mealReader.listMealTime.filter(x => x.mealUse),
        selected: this.dataItem.state.listMealTime,
        headers: [
          { text: '이름', value: 'mealName', align: 'start' },
          { text: '시작', value: 'mealFromTime', align: 'start' },
          { text: '종료', value: 'mealToTime', align: 'start' },
          { text: '가격', value: 'mealPrice', align: 'start' }
        ],
        callback: async (selected: I.MealTimeData[]) => {
          this.dataItem.state.listMealTime = selected;
        }
      },
      single: true,
      itemKey: 'mealCode'
    });
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  on = true;
  width = 820;
  height = 500;

  pageInfo = {} as I.MealSettingPageInfo;

  @Prop({ type: Number, default: 0 })
  zoneCode!: number;

  @Prop({ type: Number, default: 0 })
  acuID!: number;

  @Prop({ type: Number, default: 0 })
  portUpper!: number;

  @Prop({ type: Number, default: 0 })
  portLower!: number;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  get sensorPort() {
    return `${this.portUpper}-${this.portLower}`;
  }

  get selectReaderText() {
    if (this.dataItem.state.listReader.length !== 1) return '';
    return `${this.dataItem.state.listReader[0].doorName} (${this.dataItem.state.listReader[0].cornerName})`;
  }

  get selectMealTypeText() {
    if (this.dataItem.state.listMealTime.length !== 1) return '';
    return `${this.dataItem.state.listMealTime[0].mealName}`;
  }

  get mealTypePrice() {
    if (this.dataItem.state.listMealTime.length !== 1) return 0;
    return `${this.dataItem.state.listMealTime[0].mealPrice}`;
  }

  get empNoWithName() {
    if (!this.dataItem.state.userName || !this.dataItem.state.empno) return;
    return `${this.dataItem.state.userName} (${this.dataItem.state.empno})`;
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler, DialogHandler));

@Component
export default class AxSensorDetailSettingDialog extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }
  }
}
